export const APP_TITLE = 'Ask Kardia Admin';
export const WELCOME = 'Welcome';